import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Clock, Wrench } from 'lucide-react';

const ComingSoon = ({ gameName, gameIcon = "🚧", description = "Este juego está en desarrollo" }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
      <div className="container mx-auto px-6 py-8">
        <div className="max-w-2xl mx-auto text-center">
          
          {/* Back Button */}
          <div className="mb-8">
            <Link 
              to="/dashboard"
              className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              Volver al Dashboard
            </Link>
          </div>

          {/* Coming Soon Card */}
          <div className="bg-white rounded-2xl shadow-2xl p-12">
            <div className="text-8xl mb-6">{gameIcon}</div>
            
            <h1 className="font-cinzel text-4xl font-bold text-gray-800 mb-4">
              {gameName}
            </h1>
            
            <div className="flex items-center justify-center gap-2 text-orange-600 mb-6">
              <Clock className="w-6 h-6" />
              <span className="text-xl font-semibold">Próximamente</span>
            </div>
            
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              {description}
            </p>
            
            <div className="bg-orange-50 border border-orange-200 rounded-xl p-6 mb-8">
              <div className="flex items-center justify-center gap-3 text-orange-700 mb-3">
                <Wrench className="w-6 h-6" />
                <span className="font-semibold text-lg">En Desarrollo</span>
              </div>
              <p className="text-orange-600 text-sm">
                Estamos trabajando arduamente para traerte esta nueva experiencia de aprendizaje. 
                ¡Mantente atento a las actualizaciones!
              </p>
            </div>
            
            <Link
              to="/dashboard"
              className="bg-gradient-to-r from-emerald-500 to-emerald-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:scale-105 transition-all duration-300 inline-flex items-center gap-2 shadow-lg"
            >
              <ArrowLeft className="w-5 h-5" />
              Explorar Otros Juegos
            </Link>
          </div>
          
          {/* Progress Indicator */}
          <div className="mt-8 text-center">
            <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-2 shadow-lg">
              <div className="w-3 h-3 bg-emerald-500 rounded-full animate-pulse"></div>
              <span className="text-sm text-gray-600 font-medium">Desarrollo en progreso...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;